import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { PopupModalComponent } from '../../shared/popup-modal/popup-modal.component';

@Component({
  selector: 'vex-compile-survey',
  templateUrl: './compile-survey.component.html',
  styleUrls: ['./compile-survey.component.scss']
})
export class CompileSurveyComponent implements OnInit {
  surveyType: string;
  questionnaire: any = {
    surveyType: 'questionario',
    unitSystem: 'SYSTEM_MET',
    name: '',
    surname: '',
    age: '',
    height: '',
    weight: '',
    weistline: '',
    hip: '',
    rightThigh: '',
    leftThigh: '',
    rightArm: '',
    leftArm: '',
    activity: '',
    lifeStyle: '',
    period: '',
    periodFrequency: '',
    pathologies: '',
    therapy: '',
    allergies: '',
    consideration: '',
    belovedFood: [],
    hatedFood: [],
    terms: false,
    userId: ''
  };

  followUp: any = {
    surveyType: 'follow-up',
    unitSystem: 'SYSTEM_MET',
    weight: '',
    weistline: '',
    hip: '',
    rightThigh: '',
    leftThigh: '',
    rightArm: '',
    leftArm: '',
    like: '',
    dislike: '',
    would: '',
    consideration: '',
    userId: '',
    terms: false
  };

  cibi = [
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.LATTE"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.FIOCCHI"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.BISCOTTI"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.YOGURT_BIANCO"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.YOGURT_GRECO"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.SKYR"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.KEFIR"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.FETTE"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.PANE"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.PANE_INTEGRALE"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.PANE_SEGALE"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.PANE_CEREALI"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.GNOCCHI"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.PASTA"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.KAMUT"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.FARRO"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.ORZO"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.AVENA"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.QUINOA"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.PASTA_INTEGRALE"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.RISO"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.PATATE"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.COTTO"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.CRUDO"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.FESA"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.BRESAOLA"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.RICOTTA"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.FORMAGGIO"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.FIOCCHI_LATTE"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.CARNE_ROSSA"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.CARNE_BIANCA"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.TOFU"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.SEITAN"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.BURGER"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.CIOCCOLATO"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.PESCE"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.SALMONE"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.SALMONE_AFFUMICATO"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.TONNO"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.SGOMBRO"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.LEGUMI"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.UOVA"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.ALBUME"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.PARMIGGIANO"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.MIELE"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.MARMELLATA"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.FRUTTA"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.SPREMUTA"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.SEMI"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.OLIVE"),
    this.translate.instant("PROFILE.NUTRITION.SURVEY.FOOD.BURRO")];

  stile_vita = [this.translate.instant("PROFILE.NUTRITION.SURVEY.ACTIVE"), this.translate.instant("PROFILE.NUTRITION.SURVEY.SEDENTARY"), this.translate.instant("PROFILE.NUTRITION.SURVEY.LIGHT")];

  ciclo = [this.translate.instant("PROFILE.NUTRITION.SURVEY.REGULAR"), this.translate.instant("PROFILE.NUTRITION.SURVEY.IRREGULAR"), this.translate.instant("PROFILE.NUTRITION.SURVEY.MENOPAUSE")];

  currentStep: number = 1;

  followUpSteps: number = 2;
  questionnaireUpSteps: number = 4;
  btnSpinner: boolean = false;
  isKeyboardOpen: boolean = false;
  missingFields = [];
  lastStepPassed: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, public guiService: GuiService, public translate: TranslateService, private restService: RestService, private dialog: MatDialog) { }

  ngOnInit() {
    this.missingFields = [];
    this.lastStepPassed = false;
    this.guiService.showSpinner = false;
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['surveyType']) {
        this.surveyType = params['surveyType'];
        console.debug(this.surveyType)
      }
    });
    this.followUp.userId = this.guiService.userLogged.user.id;
    this.questionnaire.userId = this.guiService.userLogged.user.id;
    this.questionnaire.name = this.guiService.userLogged.masterData.name;
    this.questionnaire.surname = this.guiService.userLogged.masterData.lastName;
  }

  checkFollowUpPopulated(): boolean {
  const optionalFields = ['like', 'dislike', 'would'];

  return Object.keys(this.followUp).every(key => {
    if (optionalFields.includes(key)) {
      return true;
    }

    const value = this.followUp[key];

    if (key === 'terms') {
      return value !== false;
    }

    return value !== '' && value !== null && value !== undefined;
  });
}

  checkQuestionnairePopulated(): boolean {
    const obligatoryFields = ['unitSystem', 'name', 'surname', 'age', 'height', 'weight',
      'weistline', 'hip', 'rightThigh', 'leftThigh', 'rightArm', 'leftArm',
      'activity', 'lifeStyle', 'consideration', 'terms',
    ];
    return obligatoryFields.every(key => {
      const value = this.questionnaire[key];

      if (key === 'terms') {
        return value === true;
      }

      return value !== '' && value !== null && value !== undefined;
    });

  }

  sendFollowUp() {
    this.btnSpinner = true;
    this.restService.postService('node', '/send-user-survey-intermediary', this.followUp).subscribe((ris) => {
      this.getCurrent();
    })
  }

  sendQuestionnaire() {
    this.btnSpinner = true;
    this.restService.postService('node', '/send-user-survey-intermediary', this.questionnaire).subscribe((ris)=>{
      this.getCurrent();
    });
  }

  getCurrent() {
    this.restService.getService('node', 'new-current').subscribe({
      next: (ris) => {
        this.guiService.userLogged = ris;
        this.btnSpinner = false;
        this.openModal();
      },
      error: () => {
        this.guiService.doLogout();
      }
    })
  }

  openModal(): void {
  this.dialog.open(PopupModalComponent, {
    panelClass: 'custom-modal-home',
    disableClose: true,
    data: {
      title: this.translate.instant("PROFILE.NUTRITION.QUESTIONNAIRE"),
      subTitle: this.translate.instant("PROFILE.NUTRITION.QUEST-SUBMITTED"),
      buttonTitle: 'Ok',
      closeBtnTop: false,
      redirectUrl: 'main/nutrition'
    }
  }).afterClosed().subscribe(dataReturned => {
    if (dataReturned && dataReturned.callback === 'confirm') {
      this.guiService.goTo('main/user-nutrition');
    }
  });
}


  changeStep(type: string){
    this.currentStep = this.currentStep+1;
    if(type === 'questionnaire'){
      this.missingFields = this.getMissingFields();
      this.currentStep === 4 ? this.lastStepPassed = true : null;
    }else{
      this.missingFields = this.getMissingFields();
      this.currentStep === 2 ? this.lastStepPassed = true : null;
    }
  }

  getMissingFields(): string[] {
    const obligatoryFields = [
      'unitSystem', 'name', 'surname', 'age', 'height', 'weight',
      'weistline', 'hip', 'rightThigh', 'leftThigh', 'rightArm', 'leftArm',
      'activity', 'lifeStyle',
      'consideration', 'terms',
    ];

    const missing: string[] = [];

    obligatoryFields.forEach(key => {
      const value = this.questionnaire[key];

      if (key === 'terms') {
        if (value !== true) missing.push(key);
        return;
      }

      if (value === '' || value === null || value === undefined) {
        missing.push(key);
      }
    });

    return missing;
  }


}
